import React from 'react';
import {
  TextField,
  Button,
  Stack,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { buildInventorySavePayload } from '../../utils/inventorySettings';
import SelectField from '../inputs/SelectField';

export default function LotsInventorySettingsPanel({
  form,
  setField,
  onSave,
  onReset,
  saving,
  shapeOptions = [],
}) {
  const { t } = useTranslation();
  const lots = form.inventorySettings?.lots || {};

  const setLotsField = (key, value) => {
    setField('inventorySettings', {
      ...form.inventorySettings,
      lots: { ...lots, [key]: value },
    });
  };

  const handleSave = () => {
    onSave(buildInventorySavePayload(form));
  };

  const shapeSelectOptions = [
    { value: '', label: t('settings.inventory.none') },
    ...shapeOptions.map((s) => ({ value: s, label: s })),
  ];

  return (
    <Stack spacing={2.5}>
      <SelectField
        label={t('settings.inventory.lots.defaultShapeFilter')}
        value={lots.defaultShapeFilter || ''}
        onChange={(value) => setLotsField('defaultShapeFilter', value)}
        options={shapeSelectOptions}
        size="small"
        helperText={t('settings.inventory.lots.defaultShapeFilterHelp')}
      />
      <FormControlLabel
        control={(
          <Switch
            checked={lots.showAvailableWeightToClients !== false}
            onChange={(e) => setLotsField('showAvailableWeightToClients', e.target.checked)}
            size="small"
          />
        )}
        label={t('settings.inventory.lots.showAvailableWeight')}
      />
      <TextField
        label={t('settings.inventory.lots.maxAvailableDisplay')}
        value={lots.maxAvailableDisplayCt ?? ''}
        onChange={(e) => setLotsField('maxAvailableDisplayCt', e.target.value)}
        type="number"
        inputProps={{ min: 0, step: 0.1 }}
        size="small"
        sx={{ maxWidth: 280 }}
        helperText={t('settings.inventory.lots.maxAvailableDisplayHelp')}
      />
      <FormControlLabel
        control={(
          <Switch
            checked={lots.allowOrderOverStock === true}
            onChange={(e) => setLotsField('allowOrderOverStock', e.target.checked)}
            size="small"
          />
        )}
        label={t('settings.inventory.lots.allowOrderOverStock')}
      />
      <Stack direction="row" spacing={1}>
        <Button variant="contained" onClick={handleSave} disabled={saving} size="small">
          {saving ? t('common.saving') : t('common.save')}
        </Button>
        <Button onClick={onReset} disabled={saving} size="small">
          {t('common.reset')}
        </Button>
      </Stack>
    </Stack>
  );
}
